/** 合并借用的加载块；首块立即交付，后续按数量或最早等待时间提交。 */
export class MeshPartBatcher<T> {
  private pending: T[] = []
  private first = true
  private closed = false
  private timer?: ReturnType<typeof setTimeout>

  constructor(
    private readonly deliver: (parts: T[]) => void,
    private readonly onError: (error: unknown) => void
  ) {}

  push(part: T): void {
    if (this.closed) return
    this.pending.push(part)
    if (this.first || this.pending.length >= 6) {
      this.first = false
      this.flush()
    } else if (this.timer === undefined) {
      this.timer = setTimeout(() => {
        try {
          this.flush()
        } catch (error) {
          this.close()
          this.onError(error)
        }
      }, 50)
    }
  }

  flush(): void {
    clearTimeout(this.timer)
    this.timer = undefined
    if (this.closed || this.pending.length === 0) return
    const parts = this.pending
    this.pending = []
    this.deliver(parts)
  }

  close(): void {
    this.closed = true
    clearTimeout(this.timer)
    this.timer = undefined
    this.pending = []
  }
}
